import Repository from "./Repository";
import { DatePermissionParams } from "./types/Dashboards";

const resource = "/dashboard";

export default {
  getDashboard(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}`, {
      params: datePermissionParams,
    });
  },
  getMembers(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}/members`, {
      params: datePermissionParams,
    });
  },
  getOvertime(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}/overtime`, {
      params: datePermissionParams,
    });
  },
  getTimeOff(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}/pto`, {
      params: datePermissionParams,
    });
  },
  getCheckins(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}/checkins`, {
      params: datePermissionParams,
    });
  },
  getAvgLeaderScore(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}/leadScore`, {
      params: datePermissionParams,
    });
  },
  getWinRate(datePermissionParams: DatePermissionParams) {
    return Repository.get<any>(`${resource}/winRate`, {
      params: datePermissionParams,
    });
  },
};
